









































































































































































import moment from 'moment';

import { mapActions, mapGetters } from 'vuex';

import { ErrorManager } from '@/models/error';
import { countries } from '@/data/countries';
import {
  CalendarHoliday,
  ICalendarHoliday,
  ICalendarHolidayData
} from '@/models';

import Functions from '@/mixins/functions';
import mixins from '@/utils/mixins';
import auth from '@/mixins/auth';

import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';
import HolidayDetailFormDialog from '@/components/holiday/HolidayDetailFormDialog.vue';
import { IFetchCalendarHolidaysParams } from '@/services/timeoff-calendar';
import TimeOffHolidayCalendarPicker from '@/components/time-off-calendar/TimeOffHolidayCalendarPicker.vue';
import ALPage from '@/components/core/Page/ALPage.vue';
import ErrorAlert from '@/components/common/ErrorAlert.vue';

const baseMixins = mixins(Functions, auth);

interface Options extends InstanceType<typeof baseMixins> {
  $refs: {
    files: HTMLInputElement;
    holidayDetailFormDialog: InstanceType<typeof HolidayDetailFormDialog>;
  };
}

export default baseMixins
  .extend<Options>({ functional: false })
  .extend({
    components: {
      ConfirmationDialog,
      HolidayDetailFormDialog,
      TimeOffHolidayCalendarPicker,
      ALPage,
      ErrorAlert
    },

    data() {
      return {
        countries,
        loading: false,
        formDialog: false,
        deleteDialog: false,

        selectedCalendar: null as null | number,
        selectedYear: new Date().getFullYear().toString(),
        selectedCalendarHoliday: null as null | ICalendarHolidayData,

        sortDesc: true,
        search: '',
        errorMessage: '',
        deleteErrorMessage: '',

        headers: [
          {
            text: 'Holiday Name',
            sortable: false,
            value: 'name'
          },
          {
            text: 'Date',
            sortable: false,
            value: 'date'
          },
          {
            text: 'Calendar',
            sortable: false,
            value: 'calendar'
          },
          {
            text: 'Paid',
            sortable: false,
            value: 'is_paid',
            align: 'center'
          },
          {
            text: '',
            sortable: false,
            value: 'actions',
            align: 'center'
          }
        ]
      };
    },

    computed: {
      ...mapGetters({
        getCalendarHolidays: 'timeOffCalendar/getCalendarHolidays',
        calendars: 'timeOffCalendar/getTimeOffCalendars',
        latestCalendar: 'timeOffCalendar/getLatestTimeOffCalendar',
        getTimeOffCalendarById: 'timeOffCalendar/getTimeOffCalendarById'
      }),

      calendarHolidays(): ICalendarHoliday {
        return this.getCalendarHolidays(this.selectedCalendar);
      },

      errorOccurred(): boolean {
        return this.errorMessage.length > 0;
      }
    },

    async mounted() {
      await this.rebuild();
    },

    methods: {
      moment,

      ...mapActions({
        fetchCalendarHolidays: 'timeOffCalendar/fetchCalendarHolidays',
        deleteCalendarHoliday: 'timeOffCalendar/deleteCalendarHoliday',
        fetchTimeOffCalendars: 'timeOffCalendar/fetchTimeOffCalendars'
      }),

      refreshWithParams({ year, calendarId }: IFetchCalendarHolidaysParams) {
        this.selectedCalendar = calendarId;
        this.selectedYear = year!;
        this.searchCalendarHolidays(this.selectedCalendar, this.selectedYear);
      },

      goToCalendarHoliday(calendarHoliday: ICalendarHoliday) {
        this.$router.push({
          name: 'payroll-change-request-detail',
          params: {
            id: String(calendarHoliday.id)
          }
        });
      },

      openCalendarHolidayDeleteDialog(holiday: CalendarHoliday) {
        this.selectedCalendarHoliday = holiday;
        this.deleteDialog = true;
      },

      openCalendarHolidayFormDialog(holiday?: ICalendarHoliday) {
        this.$refs.holidayDetailFormDialog.open(
          this.selectedCalendar!,
          holiday
        );
      },

      clearAllErrors(): void {
        this.errorMessage = '';
        this.deleteErrorMessage = '';
      },

      closeDeleteDialog() {
        this.deleteDialog = false;
      },

      rebuild() {
        return this.fetchTimeOffCalendars().then(() => {
          if (this.latestCalendar) {
            this.selectedCalendar = this.latestCalendar.id;

            this.searchCalendarHolidays(
              this.latestCalendar.id,
              this.selectedYear
            );
          }
        });
      },

      searchCalendarHolidays(calendarId: number, year: string) {
        this.loading = true;

        return this.fetchCalendarHolidays({
          calendarId: calendarId,
          year: year
        })
          .catch(error => {
            this.errorMessage = ErrorManager.extractApiError(error);
          })
          .finally(() => {
            this.loading = false;
          });
      },

      removeCalendarHoliday(selectedCalendarHoliday: ICalendarHolidayData) {
        this.loading = true;

        this.deleteCalendarHoliday({
          calendarId: this.selectedCalendar,
          calendarHoliday: selectedCalendarHoliday
        })
          .then(() => {
            this.closeDeleteDialog();
          })
          .catch(error => {
            this.errorMessage = ErrorManager.extractApiError(error);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  });
